import { Injectable } from '@angular/core';
import { BenefitType } from '../helpers/constants';

@Injectable({providedIn: 'root'})
export class TaxAndFeesTooltipService {

  constructor() {
  }

  public setTaxAndFeesTooltip(benefitDetail: any, hasNoTaxes: boolean, isEventBenefit: boolean = false) {
    let tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT3';
    if (benefitDetail.benefitTaxCategory === 1 &&
        (benefitDetail.benefitTypeId === BenefitType.MedicalServicesOrInsurance ||
        benefitDetail.benefitTypeId === BenefitType.PrivatePensionPillarIII)) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT1_MEDICAL_PENSION3';
    }
    if (benefitDetail.benefitTaxCategory === 1 && benefitDetail.benefitTypeId === BenefitType.Fitness) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT1_FITNESS';
    }
    if (benefitDetail.benefitTaxCategory === 1 &&
        (benefitDetail.benefitTypeId === BenefitType.Transport || benefitDetail.benefitTypeId === BenefitType.ProfessionalDevelopment)) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT1_TRANSPORT_PROFESSIONALDEVELOPMENT';
    }
    if (benefitDetail.benefitTaxCategory === 1 &&
        (benefitDetail.benefitTypeId === BenefitType.GiftTicket || benefitDetail.benefitTypeId === BenefitType.GiftVoucher)) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT1_GIFTCARD_EVENT';
    }
    if ((benefitDetail.benefitTaxCategory === 2 || benefitDetail.benefitTaxCategory === 4) && benefitDetail.benefitTypeId === BenefitType.CultureTicket) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT2_CULTURE_TICKETS';
    }
    if ((benefitDetail.benefitTaxCategory === 2 || benefitDetail.benefitTaxCategory === 4) &&
        (benefitDetail.benefitTypeId === BenefitType.MealTicket ||
        benefitDetail.benefitTypeId === BenefitType.VacationTicket)) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT2_MEAL_VACATION_TICKETS';
    }
    if (benefitDetail.benefitTaxCategory === 3) {
      tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT3';
    }
    // Event overrides — only applied when benefit is part of an active event
    if (isEventBenefit) {
      if (hasNoTaxes) {
        // Within event limit → no taxes → cat1 tooltip
        tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT1_GIFTCARD_EVENT';
      } else {
        // Outside/over event limit → taxes applied → cat3 tooltip
        tooltipText = 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES_INFO_CAT3';
      }
    }
    return tooltipText;
  }
}
